import { Link as RouterLink } from "@tanstack/react-router";
// MUI
import { useColorScheme, useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Link from "@mui/material/Link";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";

import UserMenu from "./UserMenu";
import { useSidebar } from "../contexts/SidebarContext";
import { useFavicon } from "../hooks/useFavicon";

import { toggleSidebar } from "../utils/Utils";

export default function Header() {
  // With CSS variables the theme object no longer tracks the active scheme, so
  // anything switching outside CSS (image sources) must read it from here.
  const { mode, systemMode } = useColorScheme();
  const isDarkTheme = (systemMode ?? mode) === "dark";
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const { mini, toggleMini } = useSidebar();
  useFavicon();
  return (
    <AppBar
      color="inherit"
      elevation={0}
      sx={{
        // Above the sidebar so the bar runs the full width of the window.
        zIndex: (theme) => theme.zIndex.drawer + 1,
        borderBottom: "1px solid",
        borderColor: "divider",
      }}
    >
      <Toolbar sx={{ gap: 1, px: { xs: 1, sm: 1 }, position: "relative" }}>
        <IconButton
          onClick={() => (isDesktop ? toggleMini() : toggleSidebar())}
          aria-label={
            isDesktop
              ? mini
                ? "Expand navigation"
                : "Collapse navigation"
              : "Open navigation"
          }
        >
          {isDesktop && !mini ? <MenuOpenIcon /> : <MenuIcon />}
        </IconButton>
        <Link
          component={RouterLink}
          to="/"
          underline="none"
          sx={{
            display: "flex",
            // Too little room beside the menu button on a phone, so the logo
            // centres itself in the bar instead.
            position: { xs: "absolute", md: "static" },
            left: { xs: "50%", md: "auto" },
            transform: { xs: "translateX(-50%)", md: "none" },
          }}
        >
          <Box
            component="img"
            sx={{ height: { xs: 32, md: 40 }, display: "block" }}
            alt="Peter Drew Logo"
            src={
              isDarkTheme
                ? "/peter-drew-clothes-that-work-dark.png"
                : "/peter-drew-clothes-that-work.png"
            }
          />
        </Link>
        <Box sx={{ flexGrow: 1 }} />
        <UserMenu />
      </Toolbar>
    </AppBar>
  );
}
